
















import LocalNotificationList from '@ajax/vue/components/organisms/LocalNotificationList.vue'
import ShipmentSuspendNotification from '@ajax/vue/components/organisms/ShipmentSuspendNotification.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ShipmentSuspendNotification,
    LocalNotificationList,
  },
})
export default class HeaderBottomUserNotification extends Vue {
  /**
   * ホスト配下では明示的にnullを渡すこと
   */
  @Prop({ required: true })
  readonly brandEnglishName: string | null
}
